import config from '@/config'
import AWS from 'aws-sdk/global';
class CognitoIdentityServiceProvider {
    constructor() {    
    }
    configure(accessToken){
        const userPoolLoginKey = config.userPoolLoginKey;
        const logins = {};
        var cognitoCredentials = {};
        logins[userPoolLoginKey] = accessToken;
        AWS.config.region = config.region;
        const cognitoParams = {
            IdentityPoolId: config.IdentityPoolIdFileUpload,
            Logins: logins
        };
        cognitoCredentials = new AWS.CognitoIdentityCredentials(cognitoParams);
        if(cognitoCredentials.expired){
            cognitoCredentials.clearCachedId();
        }
        //console.log("my credential",cognitoCredentials);
        var cognitoidentityserviceprovider = new AWS.CognitoIdentityServiceProvider(
            {
                region: config.region,
                credentials: cognitoCredentials
            }
        );
       return cognitoidentityserviceprovider;
    }
  }
  export default new CognitoIdentityServiceProvider();